import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { Logger } from "../models/logger";
import { LoggerConfig } from "../models/logger-config";
import { LoggerConsole } from "../models/logger-console";
import { LoggerLocalStorage } from "../models/logger-localstorage";

@Injectable({ providedIn: 'root' })
export class LoggersService {
  loggers: Logger[] = []
  constructor() {
    this.buildLoggers()
  }

  buildLoggers() {
    let loggerInstance: Logger;

    this.getLoggers().subscribe((response: LoggerConfig[]) => {
      for (const logger of response.filter((logger: LoggerConfig) => logger.isActive)) {
        switch (logger.loggerName) {
          case 'console':
            loggerInstance = new LoggerConsole()
            break;
          case 'localstorage':
            loggerInstance = new LoggerLocalStorage()
            break;
          // case 'sentry':
          //   loggerInstance = this._sentrySvc
          //   break;

          default:
            break;
        }

        loggerInstance.location = logger.loggerLocation;
        this.loggers.push(loggerInstance)
      }
    })
  }

  getLoggers(): Observable<LoggerConfig[]> {
    return of([
      {
        loggerName: 'console',
        loggerLocation: '',
        isActive: true,
      },
      {
        loggerName: 'localstorage',
        loggerLocation: 'logs',
        isActive: false,
      },
      {
        loggerName: 'sentry',
        loggerLocation: 'logs',
        instance: '',
        isActive: false,
      }
    ])
  }

  handleError(error: any): Observable<any> {
    let errors: string[] = [];
    let msg: string = "";

    msg = `Status: ${error.status} - Status text: ${error.statusText}`;

    if (error.json()) {
      msg = `${msg} - Exception Message: ${error.json().exceptionMessage}`;
    }

    errors.push(msg);

    console.error('As error ocurred', errors);

    return throwError(errors)
  }
}


